import http from '../_http'

const dashboard = {
  allDashboard: (m) => { return http.post(`manager/webcastle/dashboard`, m); },
  monthDashboard: (m) => { return http.get(`manager/webcastle/dashboard/month`, m); },
  weekDashboard: (m) => { return http.get(`manager/webcastle/dashboard/week`, m); },
  dayDashboard: (m) => { return http.get(`manager/webcastle/dashboard/day`, m); },

  moduleDashboard: (m) => { return http.get(`manager/webcastle/dashboard/module`, m); },
}

export default dashboard

export { dashboard }